import React, { useEffect, useState } from "react";

import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import ChatIcon from "@mui/icons-material/Chat";
import CommentsDisabledIcon from "@mui/icons-material/CommentsDisabled";

import { useLocation, useNavigate } from "react-router-dom";
import { isVideov2 } from "../helpers/isVideo";

const GaleriaFotos = () => {
  const [imagen, setImagen] = useState({});
  const [descripcionContainer, setDescripcionContainer] = useState(false);
  const [material, setMaterial] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const location = useLocation();
  const { state } = location;

  const imagenesReel = state.imageGallery.map((item, index) => {
    return {
      _id: index,
      filename: item.filename,
      url: item.url,
      descripcion: item.description,
      title: item.title
    };
  });

  const mainImage = (img) => {
    let mainMediaFrame = document.getElementById("media-container");
    setImagen(img);

    if(isVideov2(img.url))
    {
      mainMediaFrame.style.backgroundImage = "none";
      mainMediaFrame.innerHTML = `
        <video class="media-video" controls>
          <source src="${img.url}" type="video/mp4">
          Tu navegador no soporta la reproducción de video.
        </video>
      `;
    } else {
      mainMediaFrame.style.backgroundImage = `url("${img.url}")`;
      mainMediaFrame.innerHTML = '';
    }
  };

  useEffect(() => {
    setMaterial(state.prueba);
    mainImage(imagenesReel[currentImageIndex]);
    setTimeout(() => {
      document.querySelector("footer").classList.add("d-none");
      document.querySelector("nav").classList.add("d-none");
      document.querySelector("header").classList.add("d-none");
      document.querySelector(".redireccion-pp").classList.add("d-none");
    }, 2000);
  }, [currentImageIndex]);

  const handleThumbnailClick = (index) => {
    setCurrentImageIndex(index);
  };

  const handlePreviousImage = () => {
    if (currentImageIndex === 0) {
      setCurrentImageIndex(imagenesReel.length - 1);
    } else {
      setCurrentImageIndex(currentImageIndex - 1);
    }
  };

  const handleNextImage = () => {
    if (currentImageIndex < imagenesReel.length - 1) {
      setCurrentImageIndex(currentImageIndex + 1);
    } else {
      setCurrentImageIndex(0);
    }
  };

  const MostrarDescripcion = () => {
    setDescripcionContainer(!descripcionContainer);
  };


  return (
    <div className="galeria-main">
      <div id="image-focus" className="image-focus media-image">
        <div id="media-container" className="image-focus media-image">          
        </div>
        <div className="previous-image">
          <div onClick={handlePreviousImage}>
            <NavigateBeforeIcon />
          </div>
        </div>
       
        <div className="next-image">
          <div onClick={handleNextImage}>
            <NavigateNextIcon />
          </div>
        </div>
      </div>
       <div className="descripcion-container">
          <div
            id="image-focus__description"
            className={descripcionContainer ? "image-focus__description" : "d-none"}
          >
            <h2>{imagen?.title}</h2>
            <p className="display-parrafo-galeria">{imagen?.descripcion}</p>
          </div>
          {!material && (
            <span onClick={MostrarDescripcion} className="mostrar_descripcion">
              {descripcionContainer ? <CommentsDisabledIcon /> : <ChatIcon />}
            </span>
          )}
       </div>
      <div className="galeria-barra_navegacion">
        <div className="backrole-button--container">
          <a className="button_back" href={`${state.url}`}>
            <ArrowBackIcon />
          </a>
        </div>
        <ul className="thumb">
          {imagenesReel.map((img, index) => (
            <li className="thumb-list--item" key={index}>
              <figure>
              {isVideov2(img ? img?.url : "") ? (
                  <video
                    className={img?._id === imagen?._id ? "active" : ""}
                    src={ img ? img?.url : "" }
                    autoPlay
                    muted
                    loop
                    onClick={() => handleThumbnailClick(index)}
                  />
                ) : (
                  <img
                    className={img?._id === imagen?._id ? "active" : ""}
                    src={img?.url}
                    id={img?._id}
                    alt={`imagen-${index}`}
                    onClick={() => handleThumbnailClick(index)}
                  />                
                )}
              </figure>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default GaleriaFotos;
